import axios from 'axios';
import api from '../api';
import { postMedia } from '../cortizol/media/mediaService';

/**
 * Uploads media to the server
 * @param {FormData} formData
 * @param {object} fileInfo
 * @param {string} fileInfo.name
 * @param {string} fileInfo.type
 * @param {Blob} fileInfo.file
 * @param {string} fileInfo.folderId
 * @param {string} fileInfo.credit
 * @param {Array<{localeId: string, content: string}>} fileInfo.description
 * @returns {Promise<object>}
 * @throws {Error}
 */
export const postUploadMedia = async (formData, fileInfo) => {
  const postGenerateUrlRes = await api.post(
    '/content-management/v1-0/admin/media-files:generate-upload-url',
    { originalFileName: fileInfo.name },
  );

  try {
    const { uploadUrl, publicUrl } = postGenerateUrlRes.data;
    const uploadMediaRes = await axios.put(uploadUrl, fileInfo.file, {
      headers: {
        'Content-Type': fileInfo.type,
      },
    });
    if (uploadMediaRes.status === 200) {
      return postMedia({
        name: fileInfo.name,
        folderId: fileInfo.folderId,
        url: publicUrl,
        credit: fileInfo.credit,
        description: fileInfo.description,
      });
    }
  } catch (error) {
    throw new Error(error);
  }
  return null;
};
